app.controller("homeCtrl", [
  "$scope",
  "$location",
  "getSiteDetails",
  "ngMeta",
  "checkUser",
  "$rootScope",
  function ($scope, $location, getSiteDetails, ngMeta, checkUser, $rootScope) {
    let siteConfig = fullSite;
    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }
    ngMeta.setTitle(siteConfig.shopTitle);

    var homePageElements = [];
    $scope.homePageElements = [];

    getSiteDetails
      .getHomePageElements(siteConfig.micrositeID)
      .then((result) => {
        homePageElements = result.content;
        $scope.loadMore(true, true);
        if (checkUser.isLoggedIn()) {
          getSiteDetails.getCustomerContent();
        } else {
          $rootScope.accessItems = [];
        }
      })
      .catch((err) => {});

    $scope.loadMore = (last, inview) => {
      if (homePageElements.length > 0 && last && inview)
        $scope.homePageElements.push(homePageElements.shift());
    };
  },
]);
